module.exports = __webpack_public_path__ + "static/img/vi.d37bf6e5.png";